import loadThreeDStudioLocaleBundle from 'Translations/loadThreeDStudioLocaleBundle'

const ActionCable = require('actioncable')

function loadActionCable() {
  if (typeof window === 'undefined') {
    return
  }

  window.App = window.App || {}
  if (!window.App.cable?.subscriptions) {
    window.App.cable = ActionCable.createConsumer()
  }
}

loadActionCable()

// Start fetching the active locale's translations at script-eval time so the
// bundle is registered before components hydrate (no English flash on non-EN
// pages). Resolves immediately on English pages.
const localeReady = loadThreeDStudioLocaleBundle()

window.addEventListener("load", () => {
  loadActionCable()

  localeReady.then(() => {
    const ReactRailsUJS = require("react_ujs");
    const context = require.context(
      'Pods',
      true,
      /\/ThreeDStudio\/(?!.*\.test.*$).*$/
    )

    ReactRailsUJS.useContext(context);
    ReactRailsUJS.mountComponents("#three-d-studio-elements");
  })
});
